import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-purple grain px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md glass-dark border border-[rgba(212,175,55,0.25)] p-8 md:p-10"
      >
        <div className="mb-8 text-center">
          <img src="/rythmbara-logo.png" alt="Rythmbara Dance Academy" className="mx-auto mb-4 h-24 w-24 rounded-full" />
          <h1 className="font-serif text-3xl text-[#F6F4EE]">Rythm<span className="text-gold">bara</span> Admin</h1>
          <p className="text-sm text-[#F6F4EE]/60 mt-2">Sign in to manage your academy content</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-[#F6F4EE]/70 text-xs uppercase tracking-widest">Email</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-transparent border-[rgba(212,175,55,0.3)] text-[#F6F4EE]" placeholder="admin@rythmbara.com" />
          </div>
          <div>
            <Label className="text-[#F6F4EE]/70 text-xs uppercase tracking-widest">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-transparent border-[rgba(212,175,55,0.3)] text-[#F6F4EE]" placeholder="••••••••" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full btn-gold text-[#1A0F2E] font-semibold uppercase tracking-widest py-6 hover:text-[#1A0F2E]">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
